import HitSeekerArLogo from "@/assets/HitseekerArLogo.png"
import HitSeekerArLogoDark from "@/assets/HitseekerArLogoDark.png"
import HitSeekerArLogoSmall from "@/assets/HitseekerArLogoSmall.png"
import HitSeekerLogo from "@/assets/HitseekerLogoPrimary.png"
import HitSeekerLogoDark from "@/assets/HitseekerLogoPrimaryDark.png"
import HitSeekerLogoSmall from "@/assets/HitseekerLogoSmall.png"
import { AppConfigType } from "@/model/appConfig"
import hitseekerRoutes from "@/pro/routes/hitseeker"
import proTheme from "@/pro/theme/proTheme"
import { createTheme } from "@mui/material"

const baseConfig: AppConfigType = {
  name: "hit-seeker-pro",
  subDomain: "",
  appUrl: "",
  theme: createTheme(proTheme), // Replace with your default theme
  appLogo: {
    "en-GB": {
      small: HitSeekerLogoSmall,
      logo: HitSeekerLogo,
      darkModeLogo: HitSeekerLogoDark,
    },
    "ar-SA": {
      small: HitSeekerArLogoSmall,
      logo: HitSeekerArLogo,
      darkModeLogo: HitSeekerArLogoDark,
    },
  },
  modules: {
    fileManagement: true,
    discussionForum: true,
    customerSupport: true,
  },
  routes: hitseekerRoutes,
  navbar: {
    items: [
      { label: "Home", path: "/" },
      { label: "Support", path: "/support" },
    ],
  },
  footer: {
    text: "© 2025 BMW. All rights reserved.",
  },
}
export default baseConfig
